/**
 * CP-WP-018a — sole application-layer entry for `ghg_inventory_precalculated`.
 *
 * Application code outside this allowlisted adapter must not call
 * `.from('ghg_inventory_precalculated')` directly. Enforcement:
 * `scripts/check_ghg_precalculated_direct_access.ts` and ops tooling.
 *
 * Sunset: remove after CP-WP-018c/d cutover when analysis reads use published releases.
 */
import type { SupabaseClient } from '@supabase/supabase-js';
import { supabaseClient } from '../supabase';

/** Table name — keep literal here so allowlist can key off this file alone. */
export const GHG_INVENTORY_PRECALCULATED_TABLE = 'ghg_inventory_precalculated' as const;

export const PRECALCULATED_ADAPTER_ID = 'legacy_precalculated_compatibility' as const;

/**
 * Query builder for the legacy wide precalculated inventory table.
 * Prefer higher-level inventoryAccessService methods when a typed contract fits.
 */
export function fromPrecalculated() {
  return supabaseClient.from(GHG_INVENTORY_PRECALCULATED_TABLE);
}

/** Same as fromPrecalculated, for callers that already hold a Supabase client. */
export function fromPrecalculatedOn(client: SupabaseClient) {
  return client.from(GHG_INVENTORY_PRECALCULATED_TABLE);
}
